import { Pipe, PipeTransform } from '@angular/core';

/**
 * 排序使用
 * key：排序关键词
 * order: asc/desc 升序降序
 */
@Pipe({ name: 'search' })
export class SearchPipe implements PipeTransform {
  transform(dataList: any[], key: string, value: string): any[] {
    if (!dataList || !key || !value) {
      return dataList;
    }
    return dataList.filter(option => option[key].toLowerCase().indexOf(value.toLowerCase()) === 0);
  }
}
